module.exports = __webpack_public_path__ + "img/09.f10e644f.jpg";